import { html } from "lit-html";
import { getInfoBox } from "Components/abstract/sc-e-form-field/sc-e-form-field.template";
import { getLegend } from "Components/abstract/sc-m-form-field-group/sc-m-form-field-group.template";
import { getCheckBox } from "Components/sc-e-check-box/sc-e-check-box.template";

import { CheckGroupItem, CheckGroupTemplateArgs } from "./sc-m-check-group.types";
import { ScCheckGroup } from "./sc-m-check-group";

// prettier-ignore
const renderItem = (option: CheckGroupItem, component: ScCheckGroup) => {
  const cssAllClass = option.selectAll ? "sc-m-check-group__checkbox--select-all" : "";
  return getCheckBox({
    cssClasses: ["sc-m-check-group__checkbox", "sc-m-form-field-group__item", cssAllClass],
    name: option.name,
    value: option.value,
    label: option.label,
    isRequired: option.required,
    isDisabled: option.disabled,
    isReadonly: option.readonly,
    description:"",
    errorMessage:"",
    isChecked: option.selected,
    checkedCb: (e: CustomEvent) => component.setCheckedState(option.idx, e.detail.isChecked)
  });
};

const renderItems = (component: ScCheckGroup) => {
  return html`${component.checkGroupItems.map(option => renderItem(option, component))}`;
};

// prettier-ignore
export const checkGroupTemplate = (args: CheckGroupTemplateArgs) => {
  return html`
    <fieldset class="sc-m-form-field-group__fieldset" ?disabled=${args.component.isDisabled} ?readonly=${args.component.isReadonly}>
      ${getLegend({
        isRequired: args.component.isRequired,
        legend: args.component.legend
      })}
      <div class="sc-m-form-field-group__items" aria-describedby="sc-e-text-input__info-box">
        ${renderItems(args.component)}
      </div>
    </fieldset>

    ${getInfoBox<Array<string>, ScCheckGroup>({
      formField: args.component
    })}
  `;
};
